// TypeScript schemas mirroring the legacy FastAPI /api/admin/* contracts.
//
// This file used to be its own hand-maintained ~600-line copy of
// packages/core/src/adminTypes.ts (mobile's copy), and the two drifted apart
// more than once — a field added to one silently didn't appear on the other,
// since TypeScript's structural typing doesn't flag a missing optional
// field. There is now exactly one copy: packages/core/src/adminTypes.ts.
// This file just re-exports it under web's existing `@/lib/adminTypes`
// import path so none of web's 25+ importers need to change.
//
// Add new admin wire-shape types to packages/core/src/adminTypes.ts, not
// here — see web/tests/unit/adminTypesReExport.test.ts for the guard that
// keeps this from silently regressing into a second copy.
export * from '@roomtreatment/core';
